import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
import SelectElementCmp from '@/utils/SelectElementCmp';
import TemplatesApiService from '@/modules/templates/services/registers/TemplatesApiService';
import {useGetOneTemplateForRegister} from '@/modules/templates/hooks/registers/useTemplates';

const SelectTemplate = ({value, onChange, defaultValue, ...props }) => {
  const {data: template} = useGetOneTemplateForRegister(defaultValue?.parent || value?.parent);

  const currentValue = useMemo(() => {
    const result = value || defaultValue;
    return result?.parent ? result.parent : template?.parent ? template.parent : template?._id;
  }, [defaultValue, template?._id, template?.parent, value]);

  return (
    <SelectElementCmp
      queryKey={'register-template-select'}
      service={TemplatesApiService}
      value={currentValue}
      onChange={onChange}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      {...props}
    />
  );
};

SelectTemplate.propTypes = {
  value: PropTypes.string || PropTypes.object,
  onChange: PropTypes.func,
  filters: PropTypes.object,
  defaultValue: PropTypes.object,
};
SelectTemplate.defaultProps = {
  entity: {},
};

export default memo(SelectTemplate);

const TemplateView = ({value}) => {

  return (
    <div>
      {value?.name || 'N/A'}
    </div>
  );
};

TemplateView.propTypes = {
  value: PropTypes.string
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table
 * */
export const renderTemplate = (text) => {
  return (
    <TemplateView value={text}/>
  );
};
